define('Born_CustomAlgolia/internals/template/recommend/products',[], function () {
    return {
        getItemHtml: function (item, html, addTocart) {
            let correctFKey = getCookie('form_key');
            let action = algoliaConfig.recommend.addToCartParams.action + 'product/' + item.objectID + '/';
            if(correctFKey != "" && algoliaConfig.recommend.addToCartParams.formKey != correctFKey) {
                algoliaConfig.recommend.addToCartParams.formKey = correctFKey;
            }
            if(correctFKey != "" && algoliaConfig.wishlist.wishlistParams.formKey != correctFKey) {
                algoliaConfig.wishlist.wishlistParams.formKey = correctFKey;
            }
            this.config = algoliaConfig;
            this.defaultIndexName = algoliaConfig.indexName + '_products';

            let price_value = 'price'+algoliaConfig.priceKey;
            let price_formated = 'price'+algoliaConfig.priceKey+'_formated';
            let price_original_formated = 'price'+algoliaConfig.priceKey+'_original_formated';

            let itemPriceValue = this.getPropByString(item, price_value);
            let itemPrice = this.getPropByString(item, price_formated);
            let itemOrigPrice = this.getPropByString(item, price_original_formated);
            let wishlisted = "";
            let wishlistProducts = [];                                                                                                                                                                                                                                                                          
            if (typeof JSON.parse(localStorage.getItem('mage-cache-storage')).wishlist !== 'undefined') {
                var wishlistStorage = JSON.parse(localStorage.getItem('mage-cache-storage')).wishlist;
                if (!_.isEmpty(wishlistStorage) && _.isArray(wishlistStorage.items) && wishlistStorage.items.length) {
                    _.each(wishlistStorage.items, function (wishlistItem) {
                        wishlistProducts.push(parseInt(wishlistItem.product_id));
                    });
                }
            }
            if (wishlistProducts.includes(parseInt(item.objectID))) {
                wishlisted = " wishlisted";
            }
            
            // Start : adding GTM click event data
            var categoryName = 0;
            if(item.categories.level0.length > 0) {
                categoryName = item.categories.level0.length - 1;
            }
            item.clickData = JSON.stringify({
              "name": item.name,
              "id": item.sku['0'],
              "sku": item.sku['0'],
              "price": itemPriceValue,
              "category": item.categories.level0[categoryName],
              "list": "productpage",
              "brand": item.brand,
              "position": '1',
              "currencyCode": algoliaConfig.currencyCode,
              "dimension22": item.objectID
            });
            // Stop : adding GTM click event data

            return  html`<div class="product-details product-item-info ">

                <span class="product-image-container">
                    <span class="product-image-wrapper">
                        <a class="recommend-item product-url" href="${item.url}" data-objectid=${item.objectID}  data-index=${this.defaultIndexName} data-click-info="${item.clickData}" data-track-info="${item.clickData}">
                            <img class="product-img product-image-photo" src="${item.image_url}" alt="${item.name}"/>
                        </a>
                    </span>
                </span>

                <div class="product details product-item-details">
                    <a class="recommend-item product-url" href="${item.url}" data-objectid=${item.objectID}  data-index=${this.defaultIndexName}>
                        <div class="product-name product name product-item-name">${item.name}</div>
                    </a>
                    <div class="price-box price-final_price" data-role="priceBox" data-product-id=${item.objectID} data-price-box="product-id-${item.objectID}">
                        <div class="price-wrapper-container ">
                            <span class="special-price">
                                <span class="price-container price-final_price tax weee">
                                    <span class="price-label">Special Price</span>
                                    <span id="product-price-${item.objectID}" data-price-amount="${itemPriceValue}" data-price-type="finalPrice" class="price-wrapper ">
                                        <span class="price">${itemPrice}</span>
                                    </span>
                                </span>
                            </span>
                            <span class="old-price sly-old-price">
                                <span class="price-container price-final_price tax weee">
                                    <span id="old-price-${item.objectID}" data-price-type="oldPrice" class="price-wrapper ">
                                        <span class="price">${itemOrigPrice}</span>
                                    </span>
                                </span>
                            </span>
                        </div>
                    </div>

                    ${algoliaConfig.wishlist.isWishlistEnabled && html`
                        <div class="product actions product-item-actions">
                            <div class="actions-secondary">
                                <a href="#"
                                   id="${item.objectID}"
                                   class="action towishlist wl-${item.objectID} whishlist_position_4 ${wishlisted}"
                                   title="Wish List"
                                   data-post='{"action":"${algoliaConfig.wishlist.wishlistParams.action}","data":{"product":${item.objectID},"uenc":"${algoliaConfig.wishlist.wishlistParams.uenc}"}}'
                                   data-action="add-to-wishlist" role="button">
                                    <span>Wish List</span>
                                </a>
                            </div>
                        </div>`
                    }
                    ${addTocart && html`
                        <form class="addTocartForm" action="${action}" method="post" data-role="tocart-form">
                            <input type="hidden" name="form_key" value="${algoliaConfig.recommend.addToCartParams.formKey}" />
                            <input type="hidden" name="unec" value="${AlgoliaBase64.mageEncode(action)}"/>
                            <input type="hidden" name="product" value="${item.objectID}" />
                            <button type="submit" class="action tocart primary">
                                <span>${algoliaConfig.translations.addToCart}</span>
                            </button>
                        </form>`
                    }
                </div>
            </div>`;
        },
        getHeaderHtml: function (html,title) {
            return html`<h3 class="auc-Recommend-title">${title}</h3>`;
        },
        getPropByString: function(obj, propString) {
            if (!propString)
                return obj;

            var prop, props = propString.split('.');

            for (var i = 0, iLen = props.length - 1; i < iLen; i++) {
                prop = props[i];

                var candidate = obj[prop];
                if (candidate !== undefined) {
                    obj = candidate;
                } else {
                    break;
                }
            }
            return obj[props[i]];
        }
    };
});

